import React, { useCallback } from 'react';
import TmReactTable from '../../components/utilComponents/tmReactTable/tmReactTable';

/**
 * ReviewInvoiceList (v2)
 *
 * Changes:
 *  - Functional component
 *  - Removed unused Form/Select from react-validation (was overkill for a plain <select>)
 *  - Added rel="noopener noreferrer" to target="_blank" links
 *  - Constructor typo fixed (was "porps")
 */

const COLUMNS = [
    {
        Header: 'Invoice #', accessor: 'invoiceId',
        style: { textAlign: 'center' },
        Cell: (row) => (
            <a href={`serviceCallInfo/${row.original.invoiceId}`} target="_blank" rel="noopener noreferrer">
                {row.original.invoiceId}
            </a>
        ),
    },
    { Header: 'Reason', accessor: 'reviewNote', style: { textAlign: 'center' } },
];

const ReviewInvoiceList = ({ reviewInvoice = {}, reviewPermission = {}, onInvoiceInfoFieldsChange }) => {
    const invoiceList = reviewInvoice.reviewedInvoices || [];
    const locationList = reviewInvoice.allReviewLocations || [];
    const canEdit = !!reviewPermission.edit;

    const handleChange = useCallback((e) => {
        onInvoiceInfoFieldsChange(e.target.value);
    }, [onInvoiceInfoFieldsChange]);

    return (
        <div className="pd-10 bg-white border-radius-4 box-shadow">
            <div className="row">
                <div className="col-md-4 mb-10">
                    <select
                        className="form-control form-control-sm"
                        name="location"
                        value={reviewInvoice.location || ''}
                        onChange={handleChange}
                        disabled={!canEdit}
                    >
                        {!canEdit && (
                            <option value={reviewInvoice.location}>{reviewInvoice.location}</option>
                        )}
                        {locationList.map((loc, i) => (
                            <option key={i} value={loc}>{loc}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-12">
                    <TmReactTable
                        filterable sortable={false} resizable={false}
                        data={invoiceList}
                        columns={COLUMNS}
                    />
                </div>
            </div>
        </div>
    );
};

export default React.memo(ReviewInvoiceList);
